<template>
  <div>
    <h3 class="title-page">{{ $t("reports") }}</h3>
    <div class="mdm-table">
      <div>
        <v-row class="flex-wrap">
          <v-col
            :key="report.name"
            cols="12"
            lg="4"
            sm="6"
            v-for="report in reports"
          >
            <v-card
              @click="openReport(report)"
              class="warehouse-block cursor-pointer rounded-lg card-shadow"
              height="100%"
              outlined
            >
              <div class="card_content">
                <div class="card_content_left">
                  <v-icon>mdi-file-document </v-icon>
                  <v-card-title style="word-break: normal">{{
                    $tc(report.name)
                  }}</v-card-title>
                </div>
                <div class="card_content_right">
                  <v-icon class="chevron_icon">mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!--    <MaterialReports ref="reportMaterialDialog" />-->
      <ReportBasicToolDialog ref="reportBasicToolDialog" />
    </div>
  </div>
</template>

<script>
// import MaterialReports from "@/components/reports/MaterialReports";
import ReportBasicToolDialog from "@/components/reports/ReportBasicToolDialog.vue";

export default {
  components: {
    ReportBasicToolDialog,
    // MaterialReports,
  },
  data() {
    return {
      reports: [
        // {
        //   name: "materialReport",
        //   refDialog: "reportMaterialDialog",
        // },
        {
          name: "basicToolReportsTitle",
          refDialog: "reportBasicToolDialog",
        },
      ],
    };
  },
  methods: {
    openReport(report) {
      const /**
         *@type Object
         */
        dialog = this.$refs[report.refDialog];
      if (dialog) {
        dialog.open();
      }
    },
  },
  computed: {
    roleIndex() {
      const roles = {};
      const setRole = (role) => (roles[role] = role);
      this.$store.getters.roles.forEach(setRole);
      this.$store.getters.additionalRoles.forEach(setRole);
      return roles;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../history/index.scss";
</style>
